module.exports = __webpack_public_path__ + "static/media/doubles_tierlist.86d0d524.png";